import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'moment',
    standalone: true
})

export class MomentPipe implements PipeTransform {
    transform(value: string, format = 'Do MMM YYYY'){
        return moment(value).format(format);

    }
  }



